import { render, staticRenderFns } from "./feedback_page_widget.vue?vue&type=template&id=dea9ec64&scoped=true&"
import script from "./feedback_page_widget.vue?vue&type=script&lang=js&"
export * from "./feedback_page_widget.vue?vue&type=script&lang=js&"
import style0 from "./feedback_page_widget.vue?vue&type=style&index=0&id=dea9ec64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea9ec64",
  null
  
)

export default component.exports